export default __webpack_public_path__ + "static/media/Thumb_Bottom_02.358370fc.png";